import { CCard, CCardBody, CButton } from '@coreui/react';
import { useDispatch } from 'react-redux';
import { setCustomExternalDataModal } from '../../../../../actions/subscriber';
import { setFlexibleModal } from '../../../../../actions/common';
import { useCallback } from 'react';
import CTooltip from '../../../../migration/CTooltip';
import CIcon from '@coreui/icons-react';

const ExternalDataCustomItem = ({isDisableCustomExternal}) => {
    const dispatch = useDispatch();

    const handleCreateClick = useCallback(() => {
        dispatch(setFlexibleModal({ show: false, component: '' }));
        dispatch(setCustomExternalDataModal({ show: true }));
    }, [dispatch]);

    return (
         <div className="listener-item">
              <CCard className="custom-destination">
                   <CCardBody>
                        <div className="card-title d-flex justify-content-between w-100">
                             <div className="d-flex">
                                  <img src="/assets/icons/listenlayer-favicon.svg" alt="Icon" className="icon-20 mr-2" />
                                  <h4>Create Custom External Data</h4>
                             </div>
                        </div>

                        <div className="card-text h-100">
                             Create and manage a custom external data to organize tags you have for platforms not listed in our library.
                        </div>

                        <div className={`card-icon d-flex justify-content-end`}>
                             <div className="card-header-actions">
                                  {isDisableCustomExternal && (
                                       <div style={{ position: 'relative' }} className="mr-2">
                                            <CTooltip
                                                 content={
                                                      'This account level is not available for this feature. Please contact our customer support for further instructions!'
                                                 }
                                                 placement="bottom"
                                                 advancedOptions={{
                                                      onShow(instance) {
                                                           instance.popper.className = 'tooltip-goals';
                                                      },
                                                 }}
                                            >
                                                 <span>
                                                      <CIcon icon="iconInfo" />
                                                 </span>
                                            </CTooltip>
                                       </div>
                                  )}
                                  <CButton className="addicon" color="primary" onClick={handleCreateClick} disabled = {isDisableCustomExternal}>
                                       <i className="fal fa-plus mr-1"></i>
                                       Create
                                  </CButton>
                             </div>
                        </div>
                   </CCardBody>
              </CCard>
         </div>
    );
};

export default ExternalDataCustomItem;
